/**
 * Default copy for checkout/payment error notifications.
 *
 * DEFAULT_ERROR_TITLE matches the API's GENERAL.FAILURE title so the
 * fallback toast reads the same as a respondError'd failure.
 */
export const DEFAULT_ERROR_TITLE = 'Unsuccessful';
export const DEFAULT_PAYMENT_ERROR_MESSAGE =
  'Something went wrong processing your payment. Please try again or contact support.';

/**
 * Title for payment-specific failures (card declined, 3DS failed, etc.).
 */
export const PAYMENT_FAILED_TITLE = 'Payment Failed';
